/* eslint-disable */

/* Slider Front page (Hot Matches),
	 single post (Related News),
	 events page (Featured tournaments)
**************************************************************/
var hotsSlider;
let init = false;

function HotsSliderMode() {
  let breakpoint = window.matchMedia("(min-width: 992px)");

  if (breakpoint.matches === false) {
    if (!init) {
      init = true;

      hotsSlider = new Swiper(".hot-previews", {
        direction: "horizontal",
        spaceBetween: 8,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: "true",
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 2,
          },
        },
        on: {
          slideChange: function() {
            let index = hotsSlider.activeIndex;
            let bullet = $(".swiper-pagination-bullet");
            bullet.removeClass("swiper-pagination-bullet-active");
            bullet.eq(index).addClass("swiper-pagination-bullet-active");
          },
        },
      });
    }
  } else if (breakpoint.matches === true) {
    if (hotsSlider !== undefined) hotsSlider.destroy();
    init = false;
    return;
  }
}

/* Slider section News
**************************************************************/
let newsSlider = new Swiper("#news-container", {
  init: true,
  direction: "horizontal",
  slidesPerView: 3,
  spaceBetween: 8,
  navigation: {
    nextEl: "#news-container .next",
    prevEl: "#news-container .prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    992: {
      slidesPerView: 2,
    },
  },
});

/* Slider section preview VOD's, Sreams
**************************************************************/
let videoOptions = {
  init: true,
  direction: "horizontal",
  slidesPerView: 3,
  spaceBetween: 8,
  navigation: {
    nextEl: ".preview-cards .next",
    prevEl: ".preview-cards .prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
    },
    992: {
      slidesPerView: 2,
    },
  },
}
let sliderStreams = new Swiper(".streams-container.preview-cards", videoOptions);
let sliderVods = new Swiper("#vods-container.preview-cards", videoOptions);

/* Slider section Streams
**************************************************************/
let streamsSlider = new Swiper("#streams-container", {
  init: true,
  direction: "horizontal",
  slidesPerView: 3,
  spaceBetween: 8,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  navigation: {
    nextEl: "#streams-container .next",
    prevEl: "#streams-container .prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 2.3,
    },
    992: {
      slidesPerView: 4,
    },
  },
});

/* Slider section pinned news
**************************************************************/
let pinnedSlider = new Swiper(".pinned-news", {
  init: true,
  direction: "horizontal",
  slidesPerView: 1,
  autoplay: {
    delay: 5000,
  },
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
  },
  navigation: {
    nextEl: ".pinned-button_next",
    prevEl: ".pinned-button_prev",
  },
  breakpoints: {
    320: {
      spaceBetween: 8,
    },
    992: {
      spaceBetween: 0,
    },
  },
});

/* Slider section Tournaments info
**************************************************************/
let infoSlider = new Swiper("#info-container", {
  init: true,
  direction: "horizontal",
  slidesPerView: 1,
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: "true",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 1,
    },
    992: {
      slidesPerView: 1,
    },
  },
  on: {
    slideChange: function() {
      let index = infoSlider.activeIndex;
      let bullet = $(".swiper-pagination-bullet");
      $(".scroll-navigation__list-item").removeClass("active");
      $("[data-swiper]")
        .eq(index)
        .parent()
        .addClass("active");
      bullet.removeClass("swiper-pagination-bullet-active");
      bullet.eq(index).addClass("swiper-pagination-bullet-active");
    },
  },
});

let swiperItems = $("[data-swiper]");
swiperItems.first().on("click", function() {
  infoSlider.slidePrev();
});
swiperItems.last().on("click", function() {
  infoSlider.slideNext();
});

/* On Load
**************************************************************/
window.addEventListener("load", function() {
  HotsSliderMode();
});

/* On Resize
**************************************************************/
window.addEventListener("resize", function() {
  HotsSliderMode();
});

export { newsSlider, streamsSlider, pinnedSlider, infoSlider, sliderStreams, sliderVods };



// WEBPACK FOOTER //
// ./scripts/modules/Sliders.js